
























































































































































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import {
  EAccountTypes,
  TCollectionInteractiveIcons,
  UserInterface,
  userRoles,
} from '@/types';
import { Route } from 'vue-router';
import truffleInteractiveIcons from '@/utils/truffleInteractiveIcons';

export default Vue.extend({
  name: 'Sidebar',
  created() {
    this.$store.commit('initSideBarMini');
  },

  mounted() {
    this.currentAccountType = this.accountType;
  },

  watch: {
    accountType(newValue) {
      if (newValue) {
        this.currentAccountType = newValue;
      }
    },
  },

  computed: {
    ...mapGetters({
      getUser: 'getUser',
      userCan: 'userCan',
      getRoles: 'getRoles',
    }),
    user(): UserInterface {
      return this.getUser;
    },
    sidebarMini(): boolean {
      return this.$store.state.sideBarMini;
    },
    instanceRoute(): Route {
      return this.$route;
    },
    dashboardActive(): boolean {
      return this.instanceRoute.name === 'Dashboard';
    },
    modalAnaliticsActive(): boolean {
      return (
        this.modalAnalitics ||
        (this.instanceRoute.name === 'ReportBuilder' && !this.sidebarMini) ||
        (this.instanceRoute.name === 'ExistReports' && !this.sidebarMini)
      );
    },
    modalStatisticsActive(): boolean {
      return (
        this.modalStatistics ||
        (this.instanceRoute.name == 'CampaignStatistics' &&
          !this.sidebarMini) ||
        (this.instanceRoute.name == 'SspStatistics' && !this.sidebarMini) ||
        (this.instanceRoute.name == 'CreativeStatistics' &&
          !this.sidebarMini) ||
        (this.instanceRoute.name == 'LeadStatistics' && !this.sidebarMini) ||
        (this.instanceRoute.name == 'SiteStatistics' && !this.sidebarMini)
      );
    },
    campaignGroupsActive(): boolean {
      return this.instanceRoute.meta?.group === 'group';
    },
    campaignActive(): boolean {
      return this.instanceRoute.meta?.group === 'campaign';
    },
    analiticsActive(): boolean {
      return this.instanceRoute.meta?.group === 'analitics';
    },
    statisticsActive(): boolean {
      return this.instanceRoute.meta?.group === 'statistic';
    },
    audienceActive(): boolean {
      return this.instanceRoute.meta?.group === 'audience';
    },
    moderationActive(): boolean {
      return this.instanceRoute.meta?.group === 'moderation';
    },
    inventoryActive(): boolean {
      return this.instanceRoute.meta?.group === 'inventory';
    },
    reportActive(): boolean {
      return this.instanceRoute.meta?.group === 'report';
    },
    accountType(): string {
      return this.$route.meta?.accountType;
    },
    isAccountTypeAdvertiser(): boolean {
      return this.currentAccountType === EAccountTypes.ADVERTISER;
    },
    isAccountTypePublisher(): boolean {
      return this.currentAccountType === EAccountTypes.PUBLISHER;
    },
    checkRolesForToggle(): boolean {
      if (
        this.userCan(this.roles.MANAGER) &&
        this.userCan(this.roles.PUBLISHER)
      ) {
        return true;
      }

      return false;
    },
    isNotManager(): boolean {
      return !this.getRoles.includes(this.roles.MANAGER);
    },
    truffleInteractiveIcons(): TCollectionInteractiveIcons {
      return truffleInteractiveIcons;
    },
  },
  methods: {
    changeSizeSidebar() {
      this.$store.commit('changeSideBarMini');
    },
    modalSettingsClose() {
      this.modalSettings = false;
    },
    modalAnaliticsClose() {
      this.modalAnalitics = false;
    },
  },
  data: function () {
    return {
      modalSettings: false,
      modalAnalitics: false,
      modalStatistics: false,
      currentAccountType: EAccountTypes.ADVERTISER as string,
      roles: {
        ADMIN: userRoles.ADMIN,
        MANAGER: userRoles.MANAGER,
        SSP: userRoles.SSP,
        PUBLISHER: userRoles.PUBLISHER,
      },
    };
  },
});
